import { generateDurationOptions } from "@gymflow/helpers";

export const INTERVAL_ALIGNMENT_VALUES = Array.from(
  { length: (60 / 5) * 8 },
  (_, i) => (i + 1) * 5,
);

export const selectOptions = generateDurationOptions({
  intervalsInMinutes: 5,
  hours: 4,
});

export const selectOptionsBlockExtraTime = [
  { id: "0", label: "0 Minutes", value: 0 },
  ...selectOptions,
];
